(function () {
  function findVariant(variants, selectedOptions) {
    return variants.find(v => {
      return (v.options || []).every((opt, idx) => opt === selectedOptions[idx]);
    });
  }

  function init(root) {
    const wrappers = root.querySelectorAll("[data-inline-quick-add]");
    wrappers.forEach((wrap) => {
      const jsonEl = wrap.querySelector("script[type='application/json']");
      if (!jsonEl) return;

      let variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch { return; }

      const selects = wrap.querySelectorAll("select[data-option-index]");
      const hiddenId = wrap.querySelector("input[name='id']");
      const submit = wrap.querySelector("button[type='submit']");
      const openBtn = wrap.querySelector("[data-inline-open]");
      const closeBtn = wrap.querySelector("[data-inline-close]");
      const panel = wrap.querySelector("[data-inline-panel]");

      if (!hiddenId || !submit) return;

      const sync = () => {
        const selected = Array.from(selects).map(s => s.value);
        const variant = findVariant(variants, selected);

        if (variant && variant.available) {
          hiddenId.value = variant.id;
          submit.disabled = false;
          submit.setAttribute("aria-disabled", "false");
        } else {
          hiddenId.value = "";
          submit.disabled = true;
          submit.setAttribute("aria-disabled", "true");
        }
      };

      // open/close
      if (openBtn && panel) {
        openBtn.addEventListener("click", (e) => {
          e.preventDefault();
          wrap.classList.add("is-open");
          sync();
          // focus first select (better mobile UX)
          const first = selects[0];
          if (first) first.focus();
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener("click", (e) => {
          e.preventDefault();
          wrap.classList.remove("is-open");
        });
      }

      selects.forEach(s => s.addEventListener("change", sync));
      sync();

      // Click outside closes (nice on mobile)
      document.addEventListener("click", (e) => {
        if (!wrap.classList.contains("is-open")) return;
        if (wrap.contains(e.target)) return;
        wrap.classList.remove("is-open");
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => init(document));
})();
document.querySelectorAll('[data-inline-quick-add]').forEach(card => {
  const panel = card.querySelector('[data-inline-panel]');
  if (!panel) return;

 const wrapper = card.closest('.card-wrapper') || card;

wrapper.addEventListener('mouseenter', () => {
  if (window.innerWidth > 768) {
    document.querySelectorAll('[data-inline-quick-add].is-open').forEach(openCard => {
      if (openCard !== card) openCard.classList.remove('is-open');
    });

    card.classList.add('is-open');
  }
});


wrapper.addEventListener('mouseleave', () => {
  card.classList.remove('is-open');
});

});
